import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { CurrentUser, LoginPayload } from '@/types/auth'
import { login as loginApi } from '@/api/auth'

const TOKEN_KEY = 'zek_admin_token'
const USER_KEY = 'zek_admin_user'

// 安全的存储操作封装
function safeSetStorage(key: string, value: string): void {
  try {
    sessionStorage.setItem(key, value)
  } catch (error) {
    console.error('存储失败:', error)
  }
}

function safeGetStorage(key: string): string | null {
  try {
    return sessionStorage.getItem(key)
  } catch (error) {
    console.error('读取存储失败:', error)
    return null
  }
}

function safeRemoveStorage(key: string): void {
  try {
    sessionStorage.removeItem(key)
  } catch (error) {
    console.error('移除存储失败:', error)
  }
}

export const useAuthStore = defineStore('auth', () => {
  const token = ref<string | null>(safeGetStorage(TOKEN_KEY))
  const user = ref<CurrentUser | null>(null)

  // 从存储恢复用户信息
  function restoreUser() {
    const savedUser = safeGetStorage(USER_KEY)
    if (savedUser) {
      try {
        user.value = JSON.parse(savedUser)
      } catch (error) {
        console.error('解析用户信息失败:', error)
        // 清除损坏的数据
        safeRemoveStorage(USER_KEY)
        safeRemoveStorage(TOKEN_KEY)
        token.value = null
      }
    }
  }

  // 初始化时恢复用户信息
  restoreUser()

  async function login(payload: LoginPayload) {
    const result = await loginApi(payload)
    token.value = result.token
    user.value = result.user
    safeSetStorage(TOKEN_KEY, result.token)
    safeSetStorage(USER_KEY, JSON.stringify(result.user))
  }

  function logout() {
    token.value = null
    user.value = null
    safeRemoveStorage(TOKEN_KEY)
    safeRemoveStorage(USER_KEY)
  }

  return { token, user, login, logout }
})
